import { useQuery } from 'react-query';
import moment from 'moment';
import { getAgeLimitsApi } from 'api/report';

const FALLBACK_MAX_AGE = 85;

// Same rule as the backend: not yet turned (max age + 1), and not in the future.
const fallback = () => {
  const minDob = moment()
    .subtract(FALLBACK_MAX_AGE + 1, 'years')
    .add(1, 'day')
    .format('YYYY-MM-DD');
  return {
    principalMaxAge: FALLBACK_MAX_AGE,
    dependantMaxAge: FALLBACK_MAX_AGE,
    principalMinDob: minDob,
    dependantMinDob: minDob,
    maxDob: moment().format('YYYY-MM-DD'),
  };
};

export const useAgeLimits = () => {
  const { data } = useQuery(['age-limits'], getAgeLimitsApi, {
    staleTime: 60 * 60 * 1000,
    retry: 1,
  });
  return { ...fallback(), ...(data || {}) };
};
